<template>
    <div class="compare">
        <div class="padding">

        <div v-if="commute_is('ebikeable')">
            <p>
            <span v-if="commute_is('bikeable')">
                <span v-if="commute_count === 1">
                {{ $t('compare.commute-is-bikeable') }}
                {{ $t('compare.pick-a-scenario') }}
                </span>
                <span v-else>
                {{ $t('compare.commute-n-is-bikeable', {number: commute.number}  ) }}
                {{ $t('compare.pick-a-scenario') }}
                </span>
            </span>
            <span v-else-if="commute_is('ebikeable')">
                <span v-if="commute_count == 1">
                {{ $t('compare.commute-is-e-bikeable') }} 
                {{ $t('compare.pick-a-scenario') }}
                </span>
                <span v-else>
                {{ $t('compare.commute-n-is-e-bikeable', {number: commute.number}  ) }}
                {{ $t('compare.pick-a-scenario') }}
                </span>
                
                
            </span>
            </p>
            <RadioGroup
            :items=vehicle_purchase_choices
            :default_val=vehicle_purchase_choice
            v-model=vehicle_purchase_choice
            />
                        
            <div v-if="['buy', 'sell'].includes(vehicle_purchase_choice)" >
                <h3>{{ $t('compare.budget.title') }}</h3>
                    <p>
                    {{ $t('compare.budget.info') }}
                    </p>
                    <SelectRange 
                    :min="budget_min"
                    :max="budget_max"
                    step=50
                    :default_value=budget
                    v-model=budget
                    :logmode=true
                    >
                    
                    <div slot="gauge">
                    {{ convert('formatMoney', budget,0) }}
                    
                     </div>
                     
                    
                    </SelectRange>
                    
                    <div class="vehicles_within_budget" >
                        <p>
                        {{ $t('compare.budget.example-vehicles', {budget: convert('formatMoney', budget,0) }) }}: 
                        </p>
                        <ul>
                            <li v-for="example in vehicles_within_budget">
                                - {{ example }}
                            </li>
                        </ul>
                    </div>
            </div>
            
            <div v-if="['buy', 'nobuy'].includes(vehicle_purchase_choice)">
                <h3>{{ $t('compare.percent-commuting-with-alt-vehicle.title') }}</h3>
                <p>{{ $t('compare.percent-commuting-with-alt-vehicle.info') }}</p>
                <SelectRange 
                    min="20"
                    max="100"
                    step=10
                    :default_value=percent_commuting_with_alt_vehicle
                    v-model=percent_commuting_with_alt_vehicle
                    >
                        <div slot="gauge">
                     {{ percent_commuting_with_alt_vehicle }} %
                     </div>
                     </SelectRange>
            
            </div>
            
            <div v-if="['buy', 'sell'].includes(vehicle_purchase_choice) " class="tablerow" >
                <br/>
                    
                <img src="icons/huh_18.png" >
                    
                <strong>
                    {{ $t('compare.savings.break-even-when', {vehicle: $t('vehicles.bicycle') })  }}
                    <u>{{  break_even_display }}
                </u><span v-if="['sell'].includes(vehicle_purchase_choice) "> *</span></strong> 
            </div>  
                    
            
            
            <h2 v-if="answered_questions.includes('vehicle_purchase_choice')">{{ $t('compare.savings')  }}</h2>

            <div v-if="answered_questions.includes('vehicle_purchase_choice')"  class="table">
                <div class="body">
                    <div v-if="vehicle_purchase_choice !== ''" class="tablerow" >
                        <div class="cell">
                            <span v-if="vehicle_electric(commute.data)" >
                                {{ $t('compare.savings.annual-electricity')  }}
                            </span>
                            <span v-else>
                                {{ $t('compare.savings.annual-fuel')  }}
                            </span>
                        </div>
                        <div class="cell">                    
                            {{  convert('formatMoney', energy_cost_savings_per_year,0)  }}
                        </div>
                    </div>
                    <div v-if="vehicle_purchase_choice !== ''" class="tablerow" >
                        <div class="cell"> 
                            {{ $t('compare.savings.annual-maintenance')  }}
                        </div>
                            
                        <div class="cell">                    
                            {{  convert('formatMoney', vehicle_maintenance_savings_per_year,0)  }}
                        </div>
                    </div>                    
                    
                    
                    <div v-if="vehicle_purchase_choice === 'sell'" class="tablerow" >
                        <div class="cell"> 
                            {{ $t('compare.savings.vehicle-cost', {vehicle: vehicle_label(this.commute.data.vehicle)} ) }}
                        </div>
                            
                        <div class="cell">                    
                            {{  convert('formatMoney', vehicle_cost_savings_per_year,0)  }}
                        </div>
                    </div>                     

                    <div  class="tablerow" >
                        <div class="cell green"> 
                        <big><b>
                        {{ $t('compare.savings.total')  }}
                        </b></big>
                        </div>
                            
                        <div class="cell green">
                            <big><b>
                            {{  convert('formatMoney', total_annual_savings,0)  }} <span v-if="['sell'].includes(vehicle_purchase_choice) "> *</span>
                            </b></big>
                        </div>
                    </div>   
                    
                </div>
            </div>
            
            <p v-if="['sell'].includes(vehicle_purchase_choice) ">
                * {{ $t('compare.totals-sell-note', {vehicle: vehicle_label(this.commute.data.vehicle)} ) }}
            </p>
            
        <hr class="spacer half" />
        </div>
        </div>
    </div>    
</template>

<script>

import RadioGroup from './RadioGroup.vue'
import SelectRange from './SelectRange.vue'
import Totals from '../mixins/Totals.js'
import Vehicles from '../mixins/Vehicles.js'
import Persistent from '../mixins/Persistent.js'
import conversions from '../conversions.js'

export default {
    mixins: [Totals, Vehicles, Persistent],

    components: {
        RadioGroup, SelectRange
    },
    data: function(){
        return {
            vehicle_purchase_choice: "",
            budget: 400,
            percent_commuting_with_alt_vehicle: 50,
            //vehicle_maintenance_savings_per_year: 0,
            //vehicle_cost_savings_per_year: 0,
            //total_annual_savings: 0,
            complete: false,
            _bikeable: true
        }
    },
    mounted() {
        this.notify_parent();
    },
    props: {
        commute : Object,
        commute_count : Number,
        energy_costs: Object,
    },
    watch : {
        total_annual_savings : function(){
            this.notify_parent();
        },
        answered_questions: function(){
            this.notify_parent();
        }
    },
    
    computed: {
        answered_questions : function(){
            let aq = []
            this.complete = false
            if(this.vehicle_purchase_choice !== ""){
                aq.push("vehicle_purchase_choice")
                this.complete = true
            }
            
            return aq
        },
        break_even_days: function(){
            let daily_savings = this.total_annual_savings / 365.25
            
            let days = this.budget / daily_savings
            
            return days
        },
        break_even_display : function(){
            // to seconds
            let t = this.break_even_days
            
            if(t === null){
                return this.$t('compare.break-even-after-over-3-years')
            }

            if(t < 63){
                return this.$t('compare.break-even-after-days', {days: parseInt(t)})
            }
            
            
            let months = (t  - (t % 7))/(365.25/12)

            if(months < 24){
                return this.$t('compare.break-even-after-months', {months: parseInt(months.toFixed(0))})
            }
            
            
    
            return this.$t('compare.break-even-after-years', {years: (months/12).toFixed(1)})

            
        },
        vehicle_maintenance_savings_per_year: function(){
            let perc = this.percent_commuting_with_alt_vehicle
            if(this.vehicle_purchase_choice == "sell"){
                perc = 100
            }
            return this.vehicle_maintenance_cost_per_year(this.commute.data) * perc/100
        }, 
        total_annual_savings: function(){
            return this.vehicle_cost_savings_per_year
                + this.energy_cost_savings_per_year
                + this.vehicle_maintenance_savings_per_year
        },
        vehicle_cost_savings_per_year: function(){
            if(this.vehicle_purchase_choice == "sell"){
                // here we have to subtract maintenance because it's already integrated into  vehicle cost
                // whereas here we want to consider it separately
                return this.vehicle_cost_per_year(this.commute.data)
            }
            return 0 // assume vehicle costs remain constant if they keep their vehicle
            
        },
        energy_cost_savings_per_year: function(){
            let perc = this.percent_commuting_with_alt_vehicle
            if(this.vehicle_purchase_choice == "sell"){
                perc = 100
            }
            let vcy =  this.vehicle_annual_energy_cost(this.commute.data)
            let diff = vcy * (parseFloat(perc)/100)
            
            return diff
        },
        vehicle_purchase_choices : function(){
        
            let vpc = [
                {
                    label: this.$t('compare.vehicle-purchase-choice.no-buy'),
                    icons: ['icons/bicycle_30.png', 'spacer'],
                    value: "nobuy"
                }]
                
                if (['public', 'other'].includes(this.commute.data.vehicle['vehicle']))
                {
                    vpc.push({
                        label: this.$t('compare.other-vehicle-purchase-choice.buy'),
                        icons: ['icons/add_18.png', 'spacer', 'icons/bicycle_30.png', 'spacer'],
                        value: "buy"
                    })
                }
            
                if (['car', 'motorcycle'].includes(this.commute.data.vehicle['vehicle']))
                {
                
                    vpc.push({
                        label: this.$t('compare.vehicle-purchase-choice.buy', {vehicle: this.vehicle_label(this.commute.data.vehicle)} ),
                        icons: ['icons/add_18.png', 'spacer', 'icons/bicycle_30.png', 'spacer'],
                        value: "buy"
                    })
                    vpc.push({
                        label: this.$t('compare.vehicle-purchase-choice.sell', {vehicle: this.vehicle_label(this.commute.data.vehicle)} ),
                        icons: ['icons/'+conversions.vehicle2IconFile(this.commute.data.vehicle) +'_18.png', 'spacer', 'icons/continue_right_18.png',  'spacer', 'icons/bicycle_30.png', 'spacer'],
                        value: "sell"
                    })
                }
            
            return vpc
        },
        vehicles_within_budget : function(){
            let vwb = []
            for(let eb in this.example_bikes){
                if(this.example_bikes[eb].price_min <= this.budget
                &&   this.example_bikes[eb].price_max >= this.budget){
                    if(!this.commute_is('bikeable')){
                        // which means it's e-bikeable
                        if(this.example_bikes[eb].electric || false){
                            vwb.push(this.example_bikes[eb].label)

                        }
                    } else {
                        vwb.push(this.example_bikes[eb].label)
                    }
                }             
            
            }
            return vwb;
        },
        budget_min: function(){
            let bm = 10000
            for(let eb in this.example_bikes){
                if(!this.commute_is('bikeable')){
                    // which means it's e-bikeable
                    if(this.example_bikes[eb].electric || false){
                        if(this.example_bikes[eb].price_min < bm){
                            bm = this.example_bikes[eb].price_min
                        }
                    }
                } else {
                    if(this.example_bikes[eb].price_min < bm){
                        bm = this.example_bikes[eb].price_min
                    }
                }
            }
            return bm
        
        },
        budget_default: function(){
            return ((this.budget_min * 2) - (this.budget_min % 50))
        },
        budget_max: function(){
            let bm = 0
            for(let eb in this.example_bikes){
                if(!this.commute_is('bikeable')){
                    // which means it's e-bikeable
                    if(this.example_bikes[eb].electric || false){
                        if(this.example_bikes[eb].price_max > bm){
                            bm = this.example_bikes[eb].price_max
                        }
                    }
                } else {
                    if(this.example_bikes[eb].price_max > bm){
                        bm = this.example_bikes[eb].price_max
                    }
                }
            }
            return bm
        
        },

    },
    methods: {
        commute_is : function(which){
            let lim = 0
            switch(which){
                case 'bikeable':
                case 'bike':
                    lim = 35
                break;
                case 'ebike':
                case 'ebikeable':
                    lim = 50
                break;
                default:
                    lim = 1000
                    
            }
            if(['bicycle', 'e-bicycle', 'other'].includes(this.commute.data.vehicle.vehicle)){
                return false // commute already is a bike ride :P
            }
            
            
            if(this.commute.data.commute_dist_time.commute_dist <= lim){
                return true;
            }
            return false;
        },
        notify_parent : function(){
            this.$data._bikeable = this.commute_is('ebikeable')
            this.save_data()
        },
        
    }
    

}
    

</script>

<style scoped>

ul {
    margin: 0;
    padding: 0 0 0 1em;
    height: 3.6em;
    overflow: hidden;

}

div.vehicles_within_budget {
}

.compare {
    text-align: left;
}

</style>